import { render, staticRenderFns } from "./EditGroupCompany.vue?vue&type=template&id=29b8e856&"
import script from "./EditGroupCompany.vue?vue&type=script&lang=js&"
export * from "./EditGroupCompany.vue?vue&type=script&lang=js&"
import style0 from "./EditGroupCompany.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports